function CommandsReducer(state = { myCommands: '', commandList: '', currentCommand: null, myCommandsCount: 0 }, action) {
    switch (action.type) {
        case "GET_MY_COMMANDS":
            return {
                ...state,
                myCommands: action.data
            }
        case "SEARCH_COMMAND":
            return {
                ...state,
                commandList: action.data
            }
        case "GET_COMMAND":
            return {
                ...state,
                currentCommand: action.data
            }
        case "MY_COMMANDS_COUNT":
            return {
                ...state,
                myCommandsCount: action.data
            }
        default:
            return state;
    }
}
export default CommandsReducer;